import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { Tooltip } from '../../../../common/tooltip'
import { EMPTY_VALUE } from '../../../../utils/common'

import { selectScoreRanges } from '../../../common/header/companyInfo/store/slice'
import { selectScore } from '../../store/slice'
import { SCORE_KEY } from './helper'
import classes from './index.module.scss'
import { ScoreRangeTooltip } from './ScoreRangeTooltip'

export const ScoreItem = ({ scoreType }) => {
  const scoreRanges = useSelector(selectScoreRanges(scoreType))
  const data = useSelector(selectScore()) || {}
  const score = data[SCORE_KEY[scoreType].SCORE]
  const scoreRangeIndex = scoreRanges.findIndex(
    (range) => score >= range.scoreRange_Min && score <= range.scoreRange_Max,
  )
  return (
    <Element className={classes.scoreItem}>
      <Element className="dFlex gap1">
        <Element className="fw600" style={{ color: '#3A414B' }}>
          <Translate value={`companySummary.score.CORPORATE_${scoreType}`} />
        </Element>
        {scoreRangeIndex !== -1 && (
          <Tooltip
            tooltipContent={
              data[SCORE_KEY[scoreType].TOOLTIP] ||
              'companySummary.score.TOOLTIP_CORPORATE_RISK_SCORE'
            }
            isI18n={!data[SCORE_KEY[scoreType].TOOLTIP]}
            tooltipContentStyle={{ width: 500 }}
          >
            <Icon
              className="icon-info-circle"
              style={{ color: '#9C9C9C', fontSize: 13 }}
            />
          </Tooltip>
        )}
      </Element>

      <Element className={classes.scoreRange}>
        {scoreRangeIndex === -1 ? (
          <Element
            className="flex1 minW0 textCenter"
            style={{
              padding: '3px 0',
              backgroundColor: '#BCBCBC',
              color: '#FFFFFF',
              fontSize: 24,
            }}
          >
            {EMPTY_VALUE}
          </Element>
        ) : (
          scoreRanges.map((item, index) => (
            <Element
              key={item.color || item.scoreRangeCode}
              className="flex1 minW0 "
              style={{
                backgroundColor: item.color || item.scoreRangeCode,
                opacity: index === scoreRangeIndex ? 1 : 0.4,
              }}
            >
              <Tooltip
                tooltipContent={
                  <ScoreRangeTooltip item={item} scoreType={scoreType} />
                }
                tooltipSpace={-5}
                contentStyle={{ width: '100%' }}
                contentClass="h100"
              >
                <Element
                  className="wh100 textCenter fw600"
                  style={{
                    padding: '3px 0',
                    color: '#191D25',
                    fontSize: 24,
                  }}
                >
                  {index === scoreRangeIndex ? score : ''}
                  &nbsp;
                </Element>
              </Tooltip>
            </Element>
          ))
        )}
      </Element>

      <Element
        className="dFlex justifyContentBetween"
        style={{ marginTop: 4, color: '#3A414B' }}
      >
        <Element>{scoreRanges[0]?.scoreRangeName}</Element>
        <Element>{scoreRanges[scoreRanges.length - 1]?.scoreRangeName}</Element>
      </Element>

      <Element className="mt1">
        {scoreRangeIndex === -1 ? (
          <Element className="fw600" style={{ color: '#3A414B' }}>
            <Translate value="companySummary.score.NO_SCORE_DATA" />
          </Element>
        ) : (
          <>
            <Element
              elementName="span"
              className="fw600"
              style={{
                color:
                  scoreRanges[scoreRangeIndex].color ||
                  scoreRanges[scoreRangeIndex].scoreRangeCode,
              }}
            >
              {scoreRanges[scoreRangeIndex]?.scoreRangeName}
            </Element>
          </>
        )}
      </Element>
    </Element>
  )
}
